//require("modules/jquery-ui/themes/black-tie/jquery-ui.css");
//require("modules/jquery-ui/themes/black-tie/jquery-ui.theme.css");

import '../Styles/site.scss';
//import './combobox';
import './entry';

//import '@fortawesome/fontawesome-free';
//import '@fortawesome/fontawesome-free/js/solid';
//import '@fortawesome/fontawesome-free/js/regular';
//import '@fortawesome/fontawesome-free/js/brands';
//import { faGuitar } from '@fortawesome/free-solid-svg-icons/faGuitar';